import { auth } from "@/util/firebase";
import type { DataInstance } from "@busy-human/gearbox"
import { Dogspaces } from "@busy-human/k9-library";
import { onAuthStateChanged } from "firebase/auth";
import { query, where } from "firebase/firestore";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useAuth } from "./auth";


export const useDogspace = defineStore('dogspaces', () => {
    
    const dogs = ref<{[id: string]: DataInstance<Dogspaces.Model>}>({});

    const asArray = computed<DataInstance<Dogspaces.Model>[]>(() => Object.values(dogs.value));

    async function refresh() {
        const existing = await Dogspaces.Collection.fetchAll();

        const tmp: typeof dogs.value = {};
        for(const remote of existing.dataItems()) {
            tmp[remote.$id] = remote;
        }
        dogs.value = { ...tmp };
    }

    onAuthStateChanged(auth, user => {
        if(user) refresh();
        else dogs.value = {};
    })
    
    return { dogs, asArray, refresh }
})